import { render, staticRenderFns } from "./PlayerKeyboardModal.vue?vue&type=template&id=6be18a5e&"
import script from "./PlayerKeyboardModal.vue?vue&type=script&lang=js&"
export * from "./PlayerKeyboardModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports